import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { OrderServicePlan } from './models/order_service_plan.model';
import { OrderService } from './services/order.service';
import { TokenStorageService } from './services/token_storage.service';
import { UserNotificationService } from './services/user-notification.service';
import { AddItemAction, NewListAction } from './store/actions/shopping.actions';
import { AppState } from './store/models/app-state.model';
import { ShoppingItem } from './store/models/shopping-item.model';
import { NavbarComponent } from "./components/navbar/navbar.component";
import { RouterModule } from "@angular/router";

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false,
})
export class AppComponent implements OnInit {
    [x: string]: any;
    shoppingItems: Observable<ShoppingItem[]> | undefined;
    newStoreCart: ShoppingItem[] = [];
    notificationsCount: number = 0;

    constructor(
        private store: Store<AppState>,
        private userService: TokenStorageService,
        private orderService: OrderService,
    ) { }

    ngOnInit(): void {
        window.addEventListener('beforeunload', (event) => {
            if (this.userService.getToken() != null) {
                this.store.dispatch(new NewListAction([]));
            }
        });
        this.updateCartIfLoggedIn();
        this.shoppingItems = this.store.select(store => store.shopping.items);
        let arr: ShoppingItem[] = [];
        this.shoppingItems.subscribe(i => arr = i);
    }


    updateCartIfLoggedIn(): void {

        if (this.userService.getToken() != null) {
            const queryParams = new Map([
                ["userId", this.userService.getUser().id],
                ["status", 'pending'],
            ]);

            this.store.dispatch(new NewListAction([]));


            this.orderService.get([], queryParams).subscribe((order) => {
                order[0].orderServicePlanModel.forEach((orderServicePlan: OrderServicePlan) => {

                    let newShoppingItem: ShoppingItem = {
                        id: orderServicePlan.servicePlanId,
                        quantity: orderServicePlan.quantity,
                        appointmentLocation: orderServicePlan.appointmentLocation,
                    }
                    this.store.dispatch(new AddItemAction(newShoppingItem));
                });
            });
        }
    }

}
